import { Component } from '@angular/core';

@Component({
  selector: 'app-main-pipe',
  templateUrl: './main-pipe.component.html',
})
export class MainPipeComponent {}
